var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTakePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5071 14.6663H10.4938C12.3338 14.6663 13.0671 13.5397 13.1538 12.1663L13.5004 6.65967C13.5938 5.21967 12.4471 3.99967 11.0004 3.99967C10.5938 3.99967 10.2204 3.76634 10.0338 3.40634L9.55377 2.43967C9.2471 1.83301 8.4471 1.33301 7.7671 1.33301H6.24044C5.55377 1.33301 4.75377 1.83301 4.4471 2.43967L3.9671 3.40634C3.78044 3.76634 3.4071 3.99967 3.00044 3.99967C1.55377 3.99967 0.407104 5.21967 0.500437 6.65967L0.847104 12.1663C0.927104 13.5397 1.6671 14.6663 3.5071 14.6663Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 5.33301H8",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99967 12.0003C8.19301 12.0003 9.16634 11.027 9.16634 9.83366C9.16634 8.64033 8.19301 7.66699 6.99967 7.66699C5.80634 7.66699 4.83301 8.64033 4.83301 9.83366C4.83301 11.027 5.80634 12.0003 6.99967 12.0003Z",
    stroke: "#5A6385",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/take-photo.3ba9935e62779bf301592f577acdfda8.svg";
export { ForwardRef as ReactComponent };